import type { LoginRequest, LoginResponse } from '../types/authTypes';
import { API_BASE } from '../config';

const BASE = `${API_BASE}/auth`;

export async function loginAdmin(req: LoginRequest): Promise<LoginResponse> {
  const res = await fetch(`${BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as { message?: string }).message ?? 'שגיאה בהתחברות');
  }

  return res.json() as Promise<LoginResponse>;
}
